import io from "socket.io-client";
import { getAuthToken } from "../../Api/common";

export const socket = io(process.env.REACT_APP_BASE_URL, {
  auth: (cb) => {
    cb({ token: getAuthToken() });
  },
  autoConnect: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 5000,
});

// Function to authenticate socket with user token
export const authenticateSocket = (token) => {
  const authToken = token || getAuthToken();
  if (authToken) {
    if (socket.connected) {
      socket.emit("authenticate", authToken);
    } else {
      socket.auth = { token: authToken };
      socket.connect();
    }
  }
};

// Listen for authentication and connection errors
socket.on("authenticated", (data) => {
  // Socket authenticated successfully
});

socket.on("authentication_error", (error) => {
  // Silently handle socket auth error when offline
});

socket.on("connect_error", (error) => {
  // Mute unhandled connection exceptions when backend server is closed
});

// Auto-authenticate when socket connects
socket.on("connect", () => {
  const token = getAuthToken();
  if (token) {
    authenticateSocket(token);
  }
});

// Re-authenticate when reconnecting
socket.on("reconnect", () => {
  const token = getAuthToken();
  if (token) {
    authenticateSocket(token);
  }
});
